import { Component, HostListener, ViewChild, inject } from '@angular/core';
import { SiaParamsAndPatternsService, SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-sp-parameters',
  templateUrl: './sia-grid-config-sp-parameters.component.html',
  styleUrls: ['./sia-grid-config-sp-parameters.component.scss'],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigSpParametersComponent extends SiaGridConfigTab {
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;
  private paramsAndPatternService = inject(SiaParamsAndPatternsService);

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfigSpParams');
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    this.gridConfFiltersTypes = this.paramsAndPatternService.operators;
  }
  onConfigFiltersRowUpdating(e: any) {}
}
